import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileValidators } from 'ngx-file-drag-drop';
import { MainService } from 'src/app/services/main.service';
import { ProjectsService } from 'src/app/services/projects.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-projects-providers-resend',
  templateUrl: './projects-providers-resend.component.html',
  styleUrls: ['./projects-providers-resend.component.scss']
})
export class ProjectsProvidersReSendComponent implements OnInit {

  bodyForm : FormData = new FormData(); 
  form!: FormGroup;
  fileControl = new FormControl([],[FileValidators.uniqueFileNames, FileValidators.maxFileCount(1)]);
  providers : any = [];
  folder : any;
  id_provider_survey : any;
  id_provider : any;
  nombre : any = "";
  hostName : any = "";
  id_campana_proyecto : any;

  sended = {
    id_provider : 0,
    id_campana_proyecto : 0, 
    id_provider_survey : 0, 
    host : "", 
    provider_msg : ""
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,    
    private fb : FormBuilder,    
    private projectService : ProjectsService,
    private main : MainService,
    private dialogRef: MatDialogRef<ProjectsProvidersReSendComponent>,
  ) { 

    this.folder = this.data.folder;
    this.id_provider_survey = this.data.id_provider_survey;
    this.nombre = this.data.nombre;
    this.id_provider = this.data.id_provider;
    this.id_campana_proyecto = this.data.id_campana_proyecto;
    
    this.hostName = window.location.protocol + '//' + window.location.host + "/providers/";
  }

  ngOnInit(): void {
    this.getProviders();
    this.loadForm();
    this.preloadFormData();
  }

  loadForm() {
    this.form = this.fb.group({
      blob : [null, {validators:[Validators.required]}],
      provider_msg : [""]
    });
  }

  preloadFormData(){
    this.bodyForm.append('folder', this.folder as string);
    this.bodyForm.append('id_provider_survey', this.id_provider_survey);
  }


  onValueChange(files : any)
  { 
    if(files.length >= 2)
    {      
      files.splice(1, 1);
      Swal.fire({
        icon: 'warning',
        title: 'Error',
        html: 'Sólo puede adjuntarse un documento'
      });
    }

    for (const item of files) {
      if(!(item.name.endsWith('.pdf')))
      {
        const index = files.indexOf(item);
  
        Swal.fire({
          icon: 'warning',
          title: 'Error',
          html: 'Solo se permiten documentos en formato .PDF'
        });
    
        if (index >= 0) {
          files.splice(index, 1);
        }
      }
    }
  }

  saveFile() {
      Swal.fire({
        title: '¿Estás seguro que deseas hacer un reenvío?',
        text: '¡Se enviará notificación a Proveedor!',
        icon: 'warning',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`
      }).then((result) => {      
        if (result.isConfirmed) {
            this.uploadFile();
        }
      });
  }

  getProviders(){
    this.projectService.getProviders().subscribe(
      (result:any) => {
       this.main.HideLoading();
       this.providers = result.data;
      },
      (err:any) => {
        this.main.HideLoading();
          Swal.fire({
            icon: 'error',
            title: 'Error al obtener registros',
            text: 'Ocurrió un error al obtener los registros de proveedores.'
          });
        
      }
    );
  }


  uploadFile(){ 
      this.sended.id_provider = this.id_provider;
      this.sended.id_campana_proyecto = this.id_campana_proyecto; 
      this.sended.id_provider_survey = this.id_provider_survey; 
      this.sended.host = this.hostName; 
      this.sended.provider_msg = this.form.controls.provider_msg.value;
      
      Swal.fire({
        icon: 'info',
        title: 'Enviando notificaciones...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      this.projectService.resendProviverSurveyEmail(this.sended).subscribe(
        (result:any)=>{
          if(result.message == 'Success'){
            Swal.fire({
              icon: 'success',
              title: 'Exito',
              text: 'Notificación enviada exitosamente'          
            }).then(() => {            
              this.dialogRef.close({ reload: true });
            });
          }
          else {
            Swal.fire({
              icon: 'error',
              title: 'Error al guardar',
              text: 'Ocurrió un error al reenviar la notificación, por favor vuelve a intentarlo.'
            });
          }
        },
        (err:any)=>{
          this.main.HideLoading();
            Swal.fire({
              icon: 'error',
              title: 'Error al guardar',
              text: 'Ocurrió un error al guardar el archivo, por favor vuelve a intentarlo.'
            });
          
        }
      );
  }

}
